<span class="border border-secondary m-1 p-1 d-inline-flex d-align-items-center bg-white">
  <button class="btn btn-sm btn-secondary" *ngIf="!isReadOnly" (click)="onDelete($event)"><span>&times;</span></button>
  <span class="ms-2 me-2">{{dateLabel}}</span>
</span>
